import * as AppHttpKit from '@/utils/http/AppHttpKit';
import * as PcHttpKit from '@/utils/http/PCHttpKit';
import { data } from 'autoprefixer';
let SERVICE_NAME = "sgb-app-manager";
let LOGIN_NAME = "enterprise-managerment-release";
let WEB_IMTOKEN = "memberCenter";
const exampleApi = {
  getLogin: (data) => AppHttpKit.postForm(`${SERVICE_NAME}/v1/app/login`,data),//登陆
  getLogout: (data) => AppHttpKit.postForm(`${SERVICE_NAME}/v1/app/logout`,data),//登出
  createQrCode:(data) => AppHttpKit.get(`${LOGIN_NAME}/api/qrscan/createQrCode`),//获取uuid
  queryQRCode:(data) => AppHttpKit.get(`${WEB_IMTOKEN}/api/qrscan/queryQRCode`, data),//获取二维码返回结果
  getCurrentUserInfo:(data) => AppHttpKit.get(`${WEB_IMTOKEN}/api/user/getCurrentUserInfo`, data),//获取扫码登陆用户的token

  getSMSLoginCode:(data) => AppHttpKit.postForm(`${SERVICE_NAME}/v1/app/register/sendSmsData`, data),//手机获取验证码
  getRegister:(data) => AppHttpKit.postForm(`${SERVICE_NAME}/v1/app/register/index`, data),//用户注册  参数 userName（手机号）、passWord（密码）、code（验证码）
  getSendSms:(data) => AppHttpKit.postForm(`${SERVICE_NAME}/v1/app/forgetPass/sendSmsData`, data),//忘记密码发送验证码   参数 mobile（手机号）
  getForgetPass:(data) => AppHttpKit.postForm(`${SERVICE_NAME}/v1/app/forgetPass/index`, data),//忘记密码修改密码   mobile（手机号）、password（密码）、code（验证码）

  getAllCompony: (data) => AppHttpKit.postForm(`${SERVICE_NAME}/v1/app/userInfo/getCurrentCompany`,data),//获取所有公司的信息
  getOrganization: (data) => AppHttpKit.postForm(`${SERVICE_NAME}/v1/app/userInfo/getOrganization`,data),//获取当前公司的信息，companyNo  companyName
  getFriendRealationShip: (data) => AppHttpKit.postForm(`${SERVICE_NAME}/v1/app/userInfo/getFriendRealationShip`,data),//拉取我的好友列表
  getQueryNewFriendList: (data) => AppHttpKit.postForm(`${SERVICE_NAME}/v1/app/userInfo/queryNewFriendList`,data),//拉取新的好友列表
  getEmpDetailByImAccount: (data) => AppHttpKit.postForm(`${SERVICE_NAME}/v1/app/userInfo/getEmpDetailByImAccount`,data),//获取用户详情

  getSysncNewFriendStatus: (data) => AppHttpKit.postForm(`${SERVICE_NAME}/v1/app/userInfo/sysncNewFriendStatus`,data),//同意添加好友
  getQueryFriendInfo: (data) => AppHttpKit.postForm(`${SERVICE_NAME}/v1/app/userInfo/queryFriendInfo`,data),//添加好友

  getQuerymenber: (data) =>　AppHttpKit.postForm(`${SERVICE_NAME}/v1/app/userInfo/queryUserByCompanyNo`, data), //模糊查询联系人
  getUserName: (data) => AppHttpKit.postForm(`${LOGIN_NAME}/v2/api/companyDepartment/findRelevanceDetailByIMAccountList`, data),

}
export default exampleApi;



// WEBPACK FOOTER //
// ./src/api/ExampleApi.js